// infcode_change - new file
import { TlsPolicy } from "../tls/policy"

export namespace InfcodeHttp {
  export type Fetch = (...args: Parameters<typeof globalThis.fetch>) => ReturnType<typeof globalThis.fetch>

  // Only InfCode-owned requests use this transport; never change the process-wide TLS default.
  export function fetch(input: Parameters<Fetch>[0], init?: BunFetchRequestInit, base: Fetch = globalThis.fetch) {
    const options: BunFetchRequestInit = {
      ...init,
      tls: { ...init?.tls, rejectUnauthorized: TlsPolicy.rejectUnauthorized() },
    }
    return base(input, options)
  }
}
